<template>
  <van-skeleton title :row="6" :loading="loading">
    <div style="display: flex;" class="heign">
      <div class="heign" style="padding-left: 10px">
        <van-sidebar style="width:3rem" v-model="activeKey">
          <van-sidebar-item style="font-size: 0.4rem" v-for="item in form" :key="item.name" :title="item.title" />
        </van-sidebar>
      </div>
      <div class="heign" style="width: 0.02rem;background-color: #ebedf0;">

      </div>
      <div class="heign" style="width: 100%;padding-bottom:100px;overflow-y: hidden;background-color: #ffffff;">
        <div style="margin: 10px">
          <div v-for="(item,index) in form" :key="item.name">
            <div v-if="activeKey==index" style="line-height: 0.5rem">
              <div v-if="item.type==1">
                <van-row>
                  <van-col span="24">
                    <div style="font-size: 0.3rem;color: #969799;margin-bottom: 0.3rem">{{ $t('说明') }}:</div>
                    <div style="font-size: 0.4rem;color:#646566">{{ item.label }}</div>
                  </van-col>
                </van-row>
                <van-row class="operating-area">
                  <van-col span="24">
                    <van-button block type="info" @click="onUpdateOrder(item)">{{item.openTitle || $t("发送指令")}}</van-button>
                  </van-col>
                </van-row>
              </div>
              <div v-else-if="item.type==2">
                <van-row>
                  <van-col span="24">
                    <div style="font-size: 0.3rem;color: #969799;margin-bottom: 0.3rem">{{ $t('说明') }}:</div>
                    <div style="font-size: 0.4rem;color:#646566">{{ item.label }}</div>
                  </van-col>
                </van-row>
                <van-row gutter="5" class="operating-area">
                  <van-col span="12">
                    <van-button block type="info"  @click="item.value=true;onUpdateOrder(item)">{{ item.openTitle }}</van-button>
                  </van-col>
                  <van-col span="12">
                    <van-button block plain type="info" @click="item.value=false;onUpdateOrder(item)">{{ item.closeTitle }}</van-button>
                  </van-col>
                </van-row>
              </div>
              <div v-else-if="item.type==3">
                <van-row>
                  <van-col span="24">
                    <div style="font-size: 0.3rem;color: #969799;margin-bottom: 0.3rem">{{ $t('说明') }}:</div>
                    <div style="font-size: 0.4rem;color:#646566">{{ item.label }}</div>
                  </van-col>
                </van-row>
                <van-row class="operating-area">
                  <van-col span="24">
                    <van-field class="cv" focus v-model="item.value"  :label="item.inputTitle" :type="item.inputType" :placeholder="$t('请输入')" />
                  </van-col>
                </van-row>
                <van-row style="margin-top: 0.5rem">
                  <van-col span="24">
                    <van-button block type="info" @click="onUpdateOrder(item,true)">{{item.openTitle || $t("发送指令")}}</van-button>
                  </van-col>
                </van-row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </van-skeleton>
</template>

<script>
import {Sidebar,SidebarItem,Notify,Row,Col,Button,Field,Toast,Skeleton} from 'vant';
import {getOrder, updateOrder} from "@/api/device";
import {setToken} from "@/util/auth";
import {getImei, setSaasId, setImei} from "@/util/session-storage-utils";
export default {
  components:{
    [Sidebar.name]:Sidebar,
    [SidebarItem.name]:SidebarItem,
    [Row.name]:Row,
    [Col.name]:Col,
    [Button.name]:Button,
    [Field.name]:Field,
    [Skeleton.name]:Skeleton,
  },
  name: "device-order",
  data(){
    return {
      activeKey:0,
      value:111,
      loading:true,
      form:[],
      activeName:null
    };
  },
  methods: {
    onChange(index) {
      Notify({ type: 'primary', message: index });
    },
    onUpdateOrder(item,check){
      if(check && !item.value){
        Toast({message:this.$t('请输入') + item.inputTitle,position:'top'});
        return
      }
      Toast.loading({message:this.$t("发送中"),duration:0,position:"top"})
      updateOrder(getImei(),{name:item.name,data:item.value}).then(() => {
        Toast.success({message:this.$t("发送成功"),position:"top"})
      })

      // item.loading = false
    },
    loadData(){
      let imei = getImei();
      getOrder(imei).then((res) => {
        this.loading = false
        if(this.activeName){
          for (let i = 0; i < res.data.length; i++) {
            if(this.activeName==res.data[i].name){
              this.activeKey = i;
              break
            }
          }
        }
        this.form = res.data;

      })
    }
  },
  created() {
    this.activeName = this.$route.query.orderActiveName;
    setToken(this.$route.query._token)
    let imei = this.$route.query._imei;
    setImei(imei)
    let saasId = this.$route.query._saasId;
    setSaasId(saasId)
    this.loadData();

  },
  activated() {
    window.console.log("order activated")
    this.loadData();
  }
}
</script>

<style>
.heign{
  height: 100%;
}
.operating-area{
  margin-top: 2rem
}
.cv .van-field__label{
  width: auto;
}
.cv .van-field__control{
  border: 0.1px solid #dcdee0;
}
.cv .van-cell{
  padding: 0;
}

</style>
